<template>
  <cube-page :title="customerName">
    <div slot="content">
      <wmq-layout
        ref="mainDashboard"
        :rootLayoutConfig="configData"
      />
    </div>
  </cube-page>
</template>

<script>
import { getFlowTime, getBigCustomerDetail } from '@/api/bigCustomer'
import CubePage from '../../components/cube-page'
import moment from 'moment'
import uiConfig from '@/config/ui-config/bigCustomer-detail-ui-config'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { set } from 'lodash'

export default {
  name: 'Detail',
  components: {
    CubePage
  },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data () {
    return {
      monthDate: undefined,
      ddiDate: undefined
    }
  },
  created () {
    this.customerName = this.$route.query.customerName + '分析'
    getFlowTime().then((res) => {
      if (res.code === 1) {
        this.monthDate = moment(res.data.monthMaxDay)
        this.ddiDate = moment(res.data.ddiMaxDay || res.data.monthMaxDay)
        this.$refs['mainDashboard'].refreshAll()
      }
    })
  },
  provide () {
    const that = this
    return {
      requestHandler: function () {
        const params = {
          date: that.monthDate.format('YYYY-MM-DD'),
          chainBrand: that.$route.query.customerName
        }
        return getBigCustomerDetail(params).then((res) => {
          if (res.code === 1) {
            const resp = {}
            resp.data = res.data
            resp.fields = {
              columns: [],
              rows: ['customerName'],
              values: [
                'provinceName',
                'yearTotalCountWithoutGift',
                'lastYearTotalCountWithoutGift',
                'comparedTotalCountWithoutGift',
                'covered',
                'branchSalesQuantityWithoutGift',
                'lastYearBranchSalesQuantityWithoutGift',
                'comparedBranchSalesQuantityWithoutGift'
              ]
            }
            resp.meta = [
              {
                field: 'customerName',
                name: '客户名称'
              },
              {
                field: 'provinceName',
                name: '省份'
              },
              {
                field: 'yearTotalCountWithoutGift',
                name: '龙牡购进数量(剔赠)',
                format: {
                  magnitude: 'default',
                  thousandsSeparatorFlag: true,
                  toFixed: 0
                }
              },
              {
                field: 'lastYearTotalCountWithoutGift',
                name: '去年同期',
                ratio: 'YOY.V',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'comparedTotalCountWithoutGift',
                name: '同比',
                ratio: 'YOY.R',
                format: {
                  suffix: '%',
                  toFixed: 0,
                  'emptyValue': '-'
                }
              },
              {
                field: 'covered',
                name: '门店覆盖家数',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'branchSalesQuantityWithoutGift',
                name: '门店纯销数量(剔赠)',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'lastYearBranchSalesQuantityWithoutGift',
                name: '去年同期',
                ratio: 'YOY.V',
                format: {
                  magnitude: 'default',
                  toFixed: 0,
                  thousandsSeparatorFlag: true
                }
              },
              {
                field: 'comparedBranchSalesQuantityWithoutGift',
                name: '同比',
                ratio: 'YOY.R',
                format: {
                  suffix: '%',
                  toFixed: 0,
                  'emptyValue': '-'
                }
              }
            ]
            resp.trackId = 'bigCustomerDetail'
            resp.widgetType = 'table'
            res.data = resp
            return new Promise((resolve) => {
              resolve(CubeDataHandle.handleCubeData(res.data))
            })
          }
        })
      }
    }
  },
  methods: {
    filedMap (fieldValue) {
      if (fieldValue < 0) {
        return {
          fill: 'red'
        }
      }
      return { fill: '#333333' }
    }
  },
  computed: {
    configData () {
      set(uiConfig, 'schema.0.children.detail.props.options.conditions', {
        text: [
          {
            field: 'comparedTotalCountWithoutGift',
            mapping: this.filedMap
          },
          {
            field: 'comparedTotalCount',
            mapping: this.filedMap
          },
          {
            field: 'comparedBranchSalesQuantity',
            mapping: this.filedMap
          },
          {
            field: 'comparedBranchSalesQuantityWithoutGift',
            mapping: this.filedMap
          }
        ]
      })
      const height = document.body.clientHeight - 50
      set(uiConfig, 'schema.0.children.detail.layout.pos.h', height)
      return uiConfig
    }
  }
}
</script>

<style lang="stylus" scoped></style>
